import React from 'react';
import {
    IconButton,
    Tooltip,
    Box,
} from '@chakra-ui/react';
import { FileCsvIcon } from '../../../../assets/icons/CsvIcon';
import { toast } from 'react-toastify';
import { useGetExportHourlyCSVMutation } from '../../api/reportsApi';
import { formatDateString } from '../../../../utils/helpers';

interface Props {
    startDate: any
    endDate: any
    deviceIds: number[]
    reportName: string
    reportType: string
    ibexPrice?: number
    groupIds?: number[] 
}

export default function ExportCsv(props: Props) {
    const [triggerExport] = useGetExportHourlyCSVMutation()
 
    const handleDownload = async () => {
        const toastId = toast.info('Exporting...', {
            style: { padding: '10px 20px' },
            autoClose: false,
            isLoading: true,
            progress: undefined,
        })
        try {
            const blob = await triggerExport({
                start: formatDateString( props.startDate),
                end: formatDateString(props.endDate),
                device_ids: props.deviceIds,
                file_name: props.reportName,
                group_ids: props.groupIds
            }).unwrap();

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${props.reportName}.csv`;
            a.click();
            window.URL.revokeObjectURL(url);


            toast.update(toastId, {
                render: 'Export successful!',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
            })
        } catch (error) {
              toast.update(toastId, {
                render: `Failed to export`,
                type: 'error',
                isLoading: false,
                autoClose: 3000,
            })
        }
    };

    return (
        <Tooltip label="CSV export" hasArrow placement="top">
            <Box>
                <IconButton
                    size="sm"
                    background="none"
                    aria-label="csv-export"
                    _focus={{ boxShadow: 'none' }}
                    icon={<FileCsvIcon boxSize="24px" />}
                    onClick={handleDownload}
                />
            </Box>
        </Tooltip>
    )
}
